import { render, staticRenderFns } from "./AdminProviderOrders.vue?vue&type=template&id=23ae035c&scoped=true&"
import script from "./AdminProviderOrders.vue?vue&type=script&lang=ts&"
export * from "./AdminProviderOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae035c",
  null
  
)

export default component.exports